import React from "react";
import "../../Assets/css/SwitchToggle.css";

const SwitchToggle = ({ checked, onChange }) => {
  return (
    <label className="switch">
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span className="slider" />
    </label>
  );
};

export default SwitchToggle;
